// Angular Ionic modules
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Components
import { MyApp } from './app.component';
import { ChartComponentModule } from '../components/chart/chart.module';
import { FooterComponentModule } from '../components/footer/footer.module';
import { ComponentsOfValueComponentModule } from '../components/components-of-value/components-of-value.module';
import { CompanyStatsBarComponentModule } from '../components/company-stats-bar/company-stats-bar.module';
import { EbitMarginDataTableComponentModule } from '../components/ebit-margin-data-table/ebit-margin-data-table.module';
import { RatesComponentModule } from '../components/rates/rates.module';
import { ValueDriversComponentModule } from '../components/value-drivers/value-drivers.module';
import { CashflowAnalysisComponentModule } from '../components/cashflow-analysis/cashflow-analysis.module';

// Pages
import { HomePageModule } from '../pages/home/home.module';

//Providers
import { EbitMarginChartOptionsProvider } from '../providers/chart-options/ebit-margin-options';
import { HistoricImpliedIroceOptionsProvider } from '../providers/chart-options/historic-implied-iroce';
import { HistoricSharePriceOptionsProvider } from '../providers/chart-options/historic-share-price';
import { HistoricEbitYearThreeRatioOptionsProvider } from '../providers/chart-options/historic-ebit-year-three-ratio';
import { HistoricEbitMarginOptionsProvider } from '../providers/chart-options/historic-ebit-margin';
import { IndexedEbitEstimateOptionsProvider } from '../providers/chart-options/indexed-ebit-estimate';
import { IroceChartOptionsProvider } from '../providers/chart-options/iroce-options';
import { WciOptionsProvider } from '../providers/chart-options/wci';
import { FaiOptionsProvider } from '../providers/chart-options/fai';
import { MedianChartOptionsProvider } from '../providers/chart-options/medians';
import { EbitVsSharePriceChartOptionsProvider } from '../providers/chart-options/ebit-vs-share-price';

import { Auth } from '../providers/auth/auth';

import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { HttpClientModule } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { CalculatorProvider } from '../providers/calculator/calculator';
import { Api } from '../providers/api/api';

import { AuthRedirectInterceptor } from '../http-interceptors/auth-redirect-interceptor';

// ngrx store
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducer } from '../reducers';
import { EffectsModule } from '@ngrx/effects';

import { CompanyEffects } from '../effects/company.effect';
import { ComparisonEffects } from '../effects/comparison.effects';
import { CompanyAnalysisEffects } from '../effects/company-analysis.effect';
import { CompaniesEffects } from '../effects/companies.effect';
import { UserEffects } from '../effects/user.effect';
import { FilterEffects } from '../effects/filter.effects';
import { SectorEffects } from '../effects/sector.effect';
import { RegionsEffects } from '../effects/regions.effects';
import { PlatformEffects } from '../effects/platform.effects';
import { UsersEffects } from '../effects/users.effects';
import { UniverseEffects } from '../effects/universe.effects';
import { ContactEffects } from '../effects/contact.effects';

import { FiltersProvider } from '../providers/filters/filters';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CompaniesProvider } from '../providers/companies/companies';
import { Title } from '@angular/platform-browser';

import { environment } from './../environments/environment';

export function jwtOptionsFactory(storage) {
  return {
    tokenGetter: () => {
      return storage.get('jwt');
    },
    authScheme: '',
    whitelistedDomains: [
      "localhost:8102",
      "mgk1mbcg72.execute-api.eu-west-1.amazonaws.com",
      "oas3k9ly1g.execute-api.eu-west-1.amazonaws.com",
      "localhost:3001",
      environment.API_ENDPOINT
    ]
  }
}
@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    HttpClientModule,
    JwtModule.forRoot({

      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [Storage]
      }
    }),
    NgxDatatableModule,
    BrowserModule,
    IonicModule.forRoot(MyApp, { preloadModules: false, iconMode: 'md', mode: 'md' }),

    StoreModule.forRoot(reducer),
    EffectsModule.forRoot([CompanyEffects, UserEffects, CompaniesEffects, CompanyAnalysisEffects
      , FilterEffects, SectorEffects, RegionsEffects, PlatformEffects, ComparisonEffects, UsersEffects
      , UniverseEffects, ContactEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 20
    }),
    IonicStorageModule.forRoot({
      name: '__ww',
      driverOrder: ['localstorage', 'sqlite', 'websql', 'indexeddb']
    }),
    ComponentsOfValueComponentModule,
    ChartComponentModule,
    HomePageModule,
    HttpModule,
    FooterComponentModule,
    CompanyStatsBarComponentModule,
    EbitMarginDataTableComponentModule,
    RatesComponentModule,
    ValueDriversComponentModule,
    CashflowAnalysisComponentModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthRedirectInterceptor,
      multi: true,
    },
    Title,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    EbitMarginChartOptionsProvider,
    HistoricImpliedIroceOptionsProvider,
    HistoricSharePriceOptionsProvider,
    HistoricEbitYearThreeRatioOptionsProvider,
    HistoricEbitMarginOptionsProvider,
    IndexedEbitEstimateOptionsProvider,
    IroceChartOptionsProvider,
    WciOptionsProvider,
    FaiOptionsProvider,
    MedianChartOptionsProvider,
    EbitVsSharePriceChartOptionsProvider,
    Auth,
    CompaniesProvider,
    CalculatorProvider,
    Api,
    FiltersProvider,
    CompaniesProvider,
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts